// import React, { useState } from 'react';
// import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode } from 'lucide-react';

// const ZenDetail = () => {
//   const [selectedAdId, setSelectedAdId] = useState(2);
//   const [viewMode, setViewMode] = useState('desktop'); // 'mobile' or 'desktop'

//   const adFormats = [
//     {
//       id: 2,
//       name: 'Zen Diamond Forced Perspective_300x600_1_300x600',
//       dimension: '300x600',
//       type: 'Banner - Javascript tag',
//       creativeId: '1552639'
//     },
    
//   ];

//   const currentAd = adFormats.find(ad => ad.id === selectedAdId) || adFormats[1];

//   const selectAd = (adId) => {
//     setSelectedAdId(adId);
//   };

//   const nextAd = () => {
//     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
//     const nextIndex = currentIndex === adFormats.length - 1 ? 0 : currentIndex + 1;
//     setSelectedAdId(adFormats[nextIndex].id);
//   };

//   const prevAd = () => {
//     const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
//     const prevIndex = currentIndex === 0 ? adFormats.length - 1 : currentIndex - 1;
//     setSelectedAdId(adFormats[prevIndex].id);
//   };

//   const AdContent = () => {
//     return (
//       <div className="relative">
//         {currentAd.dimension === '300x600' && (
//           <div className="w-full max-w-[300px] mx-auto">
//             <div className="relative w-[300px] h-[600px] rounded-lg overflow-hidden shadow-lg">
//               <video
//                 autoPlay
//                 muted
//                 loop
//                 playsInline
//                 className="w-full h-full object-cover"
//               >
//                 <source src="https://dsp.eskimi.com/files/upload/rm/upload/66f67a9f6cee9/300x600_3/images/video.mp4" playsinline muted autoPlay type="video/mp4" />
//                 {/* Fallback gradient background */}
//                 <div className="absolute inset-0 bg-gradient-to-b from-cyan-300 via-sky-400 to-blue-600 flex items-center justify-center">
//                   <div className="text-white text-center">
//                     <div className="text-3xl mb-2">✈️</div>
//                     <div className="text-xl font-bold">Turkish Airlines</div>
//                     <div className="text-sm">Your browser doesn't support video</div>
//                   </div>
//                 </div>
//               </video>
//             </div>
//           </div>
//         )}
        
       
//       </div>
//     );
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 flex mt-12 overflow-hidden">
//       {/* Left Sidebar */}
//       <div className="w-64 bg-white border-r border-gray-200 p-4 hidden lg:block">
//         <div className="mb-6">
//           <h2 className="text-lg font-semibold text-gray-800 mb-2">2025_05_Turkis...</h2>
//         </div>

//         <div className="mb-6">
//           <button className="text-sm text-blue-500 hover:underline">All creatives preview</button>
//         </div>

//         <div className="space-y-2">
//           {adFormats.map((ad) => (
//             <div 
//               key={ad.id}
//               onClick={() => selectAd(ad.id)}
//               className={`p-3 rounded-lg border cursor-pointer transition-all duration-200 hover:shadow-md ${
//                 ad.id === selectedAdId
//                   ? 'bg-blue-100 border-blue-300 shadow-sm' 
//                   : 'bg-gray-50 border-gray-200 hover:bg-gray-100 hover:border-gray-300'
//               }`}
//             >
//               <div className="text-sm font-medium text-gray-800 mb-2 truncate">
//                 {ad.name}
//               </div>
              
//               {/* Ad Preview Thumbnail */}
//               <div className="mb-3 flex justify-center">
               
//                 {ad.dimension === '300x600' && (
//                   <div className="w-12 h-24 bg-gradient-to-b from-cyan-300 to-blue-400 rounded border shadow-sm flex items-center justify-center">
//                     <div className="text-xs text-white font-bold">📹</div>
//                   </div>
//                 )}
              
//               </div>
              
//               <div className="space-y-1">
//                 <div className="text-xs text-blue-500">
//                   <span className="font-medium">Ad dimension:</span> {ad.dimension}
//                 </div>
//                 <div className="text-xs text-gray-600">
//                   <span className="font-medium">Ad type:</span> {ad.type}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Main Content */}
//       <div className="flex-1 flex flex-col">
//         {/* Header */}
//         <div className="bg-white border-b border-gray-200 px-4 lg:px-6 py-4 flex items-center justify-between">
//           <div className="flex items-center space-x-2 lg:space-x-4">
//             <h1 className="text-lg lg:text-xl font-semibold text-gray-800 truncate">
//               <span className="hidden sm:inline">Zen Diamond Forced Perspective_300x600_1_300x600</span>
//               <span className="sm:hidden">bidbox.ai</span>
//             </h1>
//             <div className="w-2 h-2 bg-gray-400 rounded-full hidden sm:block"></div>
//           </div>
          
//           <div className="flex items-center space-x-2 lg:space-x-4">
//             <div className="flex items-center bg-gray-100 rounded-lg p-1">
//               <button
//                 onClick={() => setViewMode('mobile')}
//                 className={`flex items-center space-x-1 lg:space-x-2 px-2 lg:px-3 py-2 rounded-md text-xs lg:text-sm transition-colors ${
//                   viewMode === 'mobile' 
//                     ? 'bg-purple-600 text-white' 
//                     : 'text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <Smartphone size={14} />
//                 <span className="hidden sm:inline">Mobile</span>
//               </button>
//               <button
//                 onClick={() => setViewMode('desktop')}
//                 className={`flex items-center space-x-1 lg:space-x-2 px-2 lg:px-3 py-2 rounded-md text-xs lg:text-sm transition-colors ${
//                   viewMode === 'desktop' 
//                     ? 'bg-gray-800 text-white' 
//                     : 'text-gray-600 hover:bg-gray-200'
//                 }`}
//               >
//                 <Monitor size={14} />
//                 <span className="hidden sm:inline">Desktop</span>
//               </button>
//             </div>
//           </div>
//         </div>

//         {/* Content Area */}
//         <div className="flex-1 flex flex-col lg:flex-row">
//           {/* Ad Preview */}
//           <div className="flex-1 p-2 lg:p-6">
//             {/* Navigation Buttons */}
//             <div className="flex items-center justify-center space-x-4 lg:space-x-6 mb-4 lg:mb-6">
//               <button 
//                 onClick={prevAd}
//                 className="flex items-center space-x-1 lg:space-x-2 px-3 lg:px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors text-sm"
//               >
//                 <ChevronLeft size={18} />
//                 <span className="hidden sm:inline">Prev Ad</span>
//                 <span className="sm:hidden">Prev</span>
//               </button>
              
//               <div className="text-xs lg:text-sm text-gray-500 font-medium">
//                 {adFormats.findIndex(ad => ad.id === selectedAdId) + 1} of {adFormats.length}
//               </div>
              
//               <button 
//                 onClick={nextAd}
//                 className="flex items-center space-x-1 lg:space-x-2 px-3 lg:px-4 py-2 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded-lg transition-colors text-sm"
//               >
//                 <span className="hidden sm:inline">Next Ad</span>
//                 <span className="sm:hidden">Next</span>
//                 <ChevronRight size={18} />
//               </button>
//             </div>

//             {/* Ad Container */}
//             <div className="w-full max-w-6xl mx-auto">
//               {viewMode === 'mobile' ? (
//                 // Mobile Phone Mockup
//                 <div className="max-w-sm mx-auto">
//                   <div className="bg-gray-800 rounded-3xl p-2 shadow-2xl">
//                     {/* Phone Screen */}
//                     <div className="bg-white rounded-2xl overflow-hidden" style={{aspectRatio: '9/19.5'}}>
//                       {/* Status Bar */}
//                       <div className="bg-white px-4 py-2 flex justify-between items-center text-xs font-semibold">
//                         <span>10:59 AM</span>
//                         <div className="flex items-center space-x-1">
//                           <span className="text-xs">5G</span>
//                           <div className="flex space-x-0.5">
//                             <div className="w-1 h-3 bg-black rounded-full"></div>
//                             <div className="w-1 h-3 bg-black rounded-full"></div>
//                             <div className="w-1 h-3 bg-black rounded-full"></div>
//                             <div className="w-1 h-2 bg-gray-300 rounded-full"></div>
//                           </div>
//                           <div className="w-6 h-3 border border-black rounded-sm">
//                             <div className="w-4 h-1.5 bg-black rounded-sm m-0.5"></div>
//                           </div>
//                         </div>
//                       </div>
                      
//                       {/* App Header */}
//                       <div className="bg-white px-4 py-3 border-b border-gray-100 flex items-center justify-between">
//                         <div className="text-blue-600 font-bold text-lg">bidbox.ai</div>
//                         <div className="w-6 h-6 flex flex-col justify-center space-y-1">
//                           <div className="w-full h-0.5 bg-gray-600"></div>
//                           <div className="w-full h-0.5 bg-gray-600"></div>
//                           <div className="w-full h-0.5 bg-gray-600"></div>
//                         </div>
//                       </div>
                      
//                       {/* Content Area */}
//                       <div className="bg-gray-50 p-4 flex-1 flex items-center justify-center">
//                         {/* Video Ad */}
//                         <div className="bg-white rounded-lg p-2 shadow-sm">
//                           <div className="text-xs text-gray-500 text-center mb-2">Video Advertisement</div>
//                           <AdContent />
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               ) : (
//                 // Desktop View
//                 <div className="bg-white rounded-xl shadow-lg overflow-hidden max-w-4xl mx-auto">
//                   <div className="p-8 flex items-center justify-center">
//                     {/* Video Ad - Highlighted */}
//                     <div className="border-2 border-dashed border-blue-300 rounded-lg p-4 bg-blue-50/30">
//                       <div className="text-xs text-blue-600 text-center mb-2 font-medium">Video Advertisement</div>
//                       <AdContent />
//                     </div>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </div>

//           {/* Right Sidebar */}
//           <div className="w-80 bg-white border-l border-gray-200 p-6 hidden xl:block">
//             <h3 className="text-lg font-semibold text-gray-800 mb-6">Video Creative Details</h3>
            
//             <div className="space-y-6">
//               <div className="bg-purple-50 rounded-lg p-4">
//                 <h4 className="font-medium text-purple-800 mb-3">Video Ad Info</h4>
//                 <div className="space-y-2 text-sm">
//                   <div>
//                     <span className="font-medium text-gray-700">Ad Dimension:</span>
//                     <div className="text-gray-600">{currentAd.dimension}</div>
//                   </div>
//                   <div>
//                     <span className="font-medium text-gray-700">Ad Type:</span>
//                     <div className="text-gray-600">Video - Autoplay</div>
//                   </div>
//                   <div>
//                     <span className="font-medium text-gray-700">Creative ID:</span>
//                     <div className="text-gray-600">{currentAd.creativeId}</div>
//                   </div>
//                   <div>
//                     <span className="font-medium text-gray-700">Video Properties:</span>
//                     <div className="text-gray-600 text-xs mt-1">
//                       <div>• Autoplay: Enabled</div>
//                       <div>• Muted: Yes</div>
//                       <div>• Loop: Enabled</div>
//                       <div>• Plays Inline: Yes</div>
//                     </div>
//                   </div>
//                 </div>
//                 <button className="text-blue-500 text-sm hover:underline mt-3">
//                   View Full-Size Video
//                 </button>
//               </div>

//               <div className="flex justify-center">
//                 <div className="w-32 h-32 border border-gray-300 rounded-lg flex items-center justify-center bg-white">
//                   <QrCode size={80} className="text-gray-400" />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Mobile Menu Button */}
//       <div className="lg:hidden fixed bottom-4 right-4">
//         <button className="bg-blue-600 text-white p-3 rounded-full shadow-lg">
//           <Monitor size={24} />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default ZenDetail;


import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, Smartphone, Monitor, QrCode, Play, Pause, Volume2, VolumeX, Maximize, Eye } from 'lucide-react';

const ZenDetail = () => {
  const [selectedAdId, setSelectedAdId] = useState(2);
  const [viewMode, setViewMode] = useState('desktop');
  const [isPlaying, setIsPlaying] = useState(true);
  const [isMuted, setIsMuted] = useState(true);
  const [showControls, setShowControls] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const adFormats = [
    {
      id: 2,
      name: 'Zen Diamond Forced Perspective_300x600_1_300x600',
      dimension: '300x600',
      type: 'Banner - Javascript tag',
      creativeId: '1552639'
    },
  ];

  const currentAd = adFormats.find(ad => ad.id === selectedAdId) || adFormats[0];

  const selectAd = (adId) => {
    setIsLoading(true);
    setTimeout(() => {
      setSelectedAdId(adId);
      setIsLoading(false);
    }, 300);
  };

  const nextAd = () => {
    const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    const nextIndex = currentIndex === adFormats.length - 1 ? 0 : currentIndex + 1;
    selectAd(adFormats[nextIndex].id);
  };

  const prevAd = () => {
    const currentIndex = adFormats.findIndex(ad => ad.id === selectedAdId);
    const prevIndex = currentIndex === 0 ? adFormats.length - 1 : currentIndex - 1;
    selectAd(adFormats[prevIndex].id);
  };

  const AdContent = () => {
    return (
      <div className="relative group">
        {currentAd.dimension === '300x600' && (
          <div className="w-full max-w-[300px] mx-auto">
            <div 
              className="relative w-[300px] h-[600px] rounded-2xl overflow-hidden shadow-2xl transform transition-all duration-500 hover:scale-105 hover:shadow-3xl"
              onMouseEnter={() => setShowControls(true)}
              onMouseLeave={() => setShowControls(false)}
            >
              {/* Loading overlay */}
              {isLoading && (
                <div className="absolute inset-0 bg-white/90 backdrop-blur-sm z-20 flex items-center justify-center">
                  <div className="animate-spin rounded-full h-12 w-12 border-4 border-blue-500 border-t-transparent"></div>
                </div>
              )}
              
              <video
                autoPlay={isPlaying}
                muted={isMuted}
                loop
                playsInline
                className="w-full h-full object-cover transition-all duration-300"
              >
                <source src="https://dsp.eskimi.com/files/upload/rm/upload/66f67a9f6cee9/300x600_3/images/video.mp4" type="video/mp4" />
                {/* Enhanced fallback */}
                <div className="absolute inset-0 bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 flex items-center justify-center">
                  <div className="text-white text-center animate-pulse">
                    <div className="text-6xl mb-4 animate-bounce">✈️</div>
                    <div className="text-2xl font-bold mb-2">Turkish Airlines</div>
                    <div className="text-sm opacity-80">Video not supported</div>
                  </div>
                </div>
              </video>

              {/* Video controls overlay */}
              <div className={`absolute inset-0 bg-black/0 transition-all duration-300 ${showControls ? 'bg-black/20' : ''}`}>
                <div className={`absolute bottom-4 left-4 right-4 transform transition-all duration-300 ${showControls ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`}>
                  <div className="bg-white/20 backdrop-blur-md rounded-full px-4 py-2 flex items-center justify-between">
                    <button
                      onClick={() => setIsPlaying(!isPlaying)}
                      className="text-white hover:text-blue-300 transition-colors p-1"
                    >
                      {isPlaying ? <Pause size={16} /> : <Play size={16} />}
                    </button>
                    <button
                      onClick={() => setIsMuted(!isMuted)}
                      className="text-white hover:text-blue-300 transition-colors p-1"
                    >
                      {isMuted ? <VolumeX size={16} /> : <Volume2 size={16} />}
                    </button>
                    <button className="text-white hover:text-blue-300 transition-colors p-1">
                      <Maximize size={16} />
                    </button>
                  </div>
                </div>
              </div>

              {/* Glowing border effect */}
              <div className="absolute inset-0 rounded-2xl border-2 border-transparent bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 opacity-0 group-hover:opacity-30 transition-opacity duration-500 -z-10 blur-sm"></div>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50 flex mt-12 overflow-hidden">
      {/* Left Sidebar with enhanced design */}
      <div className="w-72 bg-white/80 backdrop-blur-xl border-r border-gray-200/50 p-6 hidden lg:block shadow-xl overflow-y-auto">
        <div className="mb-8">
          <h2 className="text-xl font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent mb-2">
            2025_05_Turkish Airlines
          </h2>
          <div className="w-12 h-1 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full"></div>
        </div>

        <div className="mb-8">
          <button className="text-sm text-blue-600 hover:text-purple-600 hover:underline transition-colors duration-300 flex items-center space-x-2">
            <Eye size={16} />
            <span>All creatives preview</span>
          </button>
        </div>

        <div className="space-y-4">
          {adFormats.map((ad, index) => (
            <div 
              key={ad.id}
              onClick={() => selectAd(ad.id)}
              className={`p-4 rounded-xl border cursor-pointer transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1 ${
                ad.id === selectedAdId
                  ? 'bg-gradient-to-r from-blue-50 to-purple-50 border-blue-300 shadow-lg scale-105' 
                  : 'bg-white/50 border-gray-200 hover:bg-white/80 hover:border-gray-300'
              }`}
              style={{
                animationDelay: `${index * 0.1}s`
              }}
            >
              <div className="text-sm font-semibold text-gray-800 mb-3 truncate">
                {ad.name}
              </div>
              
              {/* Enhanced Ad Preview Thumbnail */}
              <div className="mb-4 flex justify-center">
                {ad.dimension === '300x600' && (
                  <div className="w-16 h-32 bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 rounded-lg border shadow-lg flex items-center justify-center transform transition-transform duration-300 hover:scale-110">
                    <div className="text-white font-bold text-lg animate-pulse">🎬</div>
                  </div>
                )}
              </div>
              
              <div className="space-y-2">
                <div className="text-xs">
                  <span className="font-medium text-blue-600">Dimension:</span> 
                  <span className="ml-2 px-2 py-1 bg-blue-100 text-blue-700 rounded-full text-xs">{ad.dimension}</span>
                </div>
                <div className="text-xs">
                  <span className="font-medium text-gray-600">Type:</span> 
                  <span className="ml-2 text-gray-700">{ad.type}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Enhanced Header */}
        <div className="bg-white/80 backdrop-blur-xl border-b border-gray-200/50 px-6 py-5 flex items-center justify-between shadow-sm">
          <div className="flex items-center space-x-4">
            <h1 className="text-xl font-bold bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent truncate">
              <span className="hidden sm:inline">Zen Diamond Forced Perspective</span>
              <span className="sm:hidden">bidbox.ai</span>
            </h1>
            <div className="w-2 h-2 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full animate-pulse hidden sm:block"></div>
            <span className="text-xs bg-green-100 text-green-700 px-2 py-1 rounded-full hidden sm:inline">Active</span>
          </div>
          
          <div className="flex items-center space-x-4">
            <div className="flex items-center bg-gray-100/80 backdrop-blur-sm rounded-xl p-1 shadow-inner">
              <button
                onClick={() => setViewMode('mobile')}
                className={`flex items-center space-x-2 px-4 py-3 rounded-lg text-sm transition-all duration-300 ${
                  viewMode === 'mobile' 
                    ? 'bg-gradient-to-r from-purple-500 to-pink-500 text-white shadow-lg transform scale-105' 
                    : 'text-gray-600 hover:bg-white/80 hover:shadow-sm'
                }`}
              >
                <Smartphone size={16} />
                <span className="hidden sm:inline">Mobile</span>
              </button>
              <button
                onClick={() => setViewMode('desktop')}
                className={`flex items-center space-x-2 px-4 py-3 rounded-lg text-sm transition-all duration-300 ${
                  viewMode === 'desktop' 
                    ? 'bg-gradient-to-r from-gray-700 to-gray-900 text-white shadow-lg transform scale-105' 
                    : 'text-gray-600 hover:bg-white/80 hover:shadow-sm'
                }`}
              >
                <Monitor size={16} />
                <span className="hidden sm:inline">Desktop</span>
              </button>
            </div>
          </div>
        </div>

        {/* Content Area */}
        <div className="flex-1 flex flex-col lg:flex-row min-h-0">
          {/* Ad Preview */}
          <div className="flex-1 p-4 lg:p-8 overflow-y-auto">
            {/* Enhanced Navigation */}
            <div className="flex items-center justify-center space-x-4 lg:space-x-8 mb-6 lg:mb-8">
              <button 
                onClick={prevAd}
                className="group flex items-center space-x-2 lg:space-x-3 px-4 lg:px-6 py-2 lg:py-3 bg-white/80 backdrop-blur-sm text-gray-600 hover:text-white hover:bg-gradient-to-r hover:from-blue-500 hover:to-purple-500 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-sm lg:text-base"
              >
                <ChevronLeft size={16} className="lg:w-5 lg:h-5 group-hover:animate-pulse" />
                <span className="font-medium hidden sm:inline">Previous</span>
                <span className="font-medium sm:hidden">Prev</span>
              </button>
              
              <div className="px-3 lg:px-6 py-2 lg:py-3 bg-gradient-to-r from-blue-100 to-purple-100 rounded-xl shadow-inner">
                <span className="text-xs lg:text-sm font-bold bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                  {adFormats.findIndex(ad => ad.id === selectedAdId) + 1} of {adFormats.length}
                </span>
              </div>
              
              <button 
                onClick={nextAd}
                className="group flex items-center space-x-2 lg:space-x-3 px-4 lg:px-6 py-2 lg:py-3 bg-white/80 backdrop-blur-sm text-gray-600 hover:text-white hover:bg-gradient-to-r hover:from-purple-500 hover:to-pink-500 rounded-xl transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1 text-sm lg:text-base"
              >
                <span className="font-medium hidden sm:inline">Next</span>
                <span className="font-medium sm:hidden">Next</span>
                <ChevronRight size={16} className="lg:w-5 lg:h-5 group-hover:animate-pulse" />
              </button>
            </div>

            {/* Ad Container */}
            <div className="w-full max-w-6xl mx-auto px-4">
              {viewMode === 'mobile' ? (
                // Enhanced Mobile Phone Mockup
                <div className="max-w-sm mx-auto transform transition-all duration-700 hover:scale-105">
                  <div className="bg-gradient-to-b from-gray-800 to-gray-900 rounded-3xl p-2 lg:p-3 shadow-2xl hover:shadow-3xl transition-shadow duration-500">
                    {/* Phone Screen */}
                    <div className="bg-white rounded-2xl overflow-hidden shadow-inner" style={{aspectRatio: '9/19.5'}}>
                      {/* Enhanced Status Bar */}
                      <div className="bg-gradient-to-r from-white to-gray-50 px-3 lg:px-4 py-2 lg:py-3 flex justify-between items-center text-xs font-semibold">
                        <span className="text-gray-800">1:55 PM</span>
                        <div className="flex items-center space-x-1 lg:space-x-2">
                          <span className="text-xs bg-gray-800 text-white px-1.5 py-0.5 rounded text-xs">5G</span>
                          <div className="flex space-x-0.5">
                            {[...Array(4)].map((_, i) => (
                              <div key={i} className={`w-1 h-2 lg:h-3 rounded-full ${i < 3 ? 'bg-gray-800' : 'bg-gray-300'}`}></div>
                            ))}
                          </div>
                          <div className="w-5 lg:w-6 h-2 lg:h-3 border border-gray-800 rounded-sm">
                            <div className="w-3 lg:w-4 h-1 lg:h-1.5 bg-gray-800 rounded-sm m-0.5"></div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Enhanced App Header */}
                      <div className="bg-gradient-to-r from-blue-50 to-purple-50 px-3 lg:px-4 py-3 lg:py-4 border-b border-gray-100 flex items-center justify-between">
                        <div className="text-blue-600 font-bold text-lg lg:text-xl bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent">
                          bidbox.ai
                        </div>
                        <div className="w-5 lg:w-6 h-5 lg:h-6 flex flex-col justify-center space-y-0.5 lg:space-y-1 hover:bg-gray-200 rounded p-1 transition-colors cursor-pointer">
                          {[...Array(3)].map((_, i) => (
                            <div key={i} className="w-full h-0.5 bg-gray-600 rounded"></div>
                          ))}
                        </div>
                      </div>
                      
                      {/* Content Area */}
                      <div className="bg-gradient-to-br from-gray-50 to-blue-50 p-3 lg:p-4 flex-1 flex flex-col justify-center min-h-0">
                        {/* Navigation */}
                        <div className="flex items-center justify-between mb-3 lg:mb-4 px-2">
                          <button className="flex items-center space-x-1 text-gray-500 text-xs lg:text-sm">
                            <ChevronLeft size={14} />
                            <span>Previous</span>
                          </button>
                          <span className="text-xs lg:text-sm font-semibold text-gray-600">1 of 1</span>
                          <button className="flex items-center space-x-1 text-gray-500 text-xs lg:text-sm">
                            <span>Next</span>
                            <ChevronRight size={14} />
                          </button>
                        </div>
                        
                        {/* Ad Container */}
                        <div className="bg-white rounded-xl p-2 lg:p-4 shadow-lg hover:shadow-xl transition-shadow duration-300 mx-auto">
                          <div className="text-xs text-blue-600 text-center mb-2 lg:mb-3 font-semibold flex items-center justify-center space-x-1">
                            <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                            <span>🎬 Live Video Advertisement</span>
                            <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
                          </div>
                          
                          {/* Video Ad - Mobile Optimized */}
                          <div className="relative">
                            <div className="w-full max-w-[250px] lg:max-w-[280px] mx-auto">
                              <div className="relative w-full bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 rounded-xl overflow-hidden shadow-lg" style={{aspectRatio: '300/600'}}>
                                <video
                                  autoPlay={isPlaying}
                                  muted={isMuted}
                                  loop
                                  playsInline
                                  className="w-full h-full object-cover"
                                >
                                  <source src="https://dsp.eskimi.com/files/upload/rm/upload/66f67a9f6cee9/300x600_3/images/video.mp4" type="video/mp4" />
                                  {/* Mobile Fallback */}
                                  <div className="absolute inset-0 bg-gradient-to-br from-cyan-400 via-blue-500 to-purple-600 flex items-center justify-center">
                                    <div className="text-white text-center animate-pulse">
                                      <div className="text-4xl lg:text-6xl mb-2 lg:mb-4 animate-bounce">✈️</div>
                                      <div className="text-lg lg:text-2xl font-bold mb-1 lg:mb-2">Turkish Airlines</div>
                                      <div className="text-xs lg:text-sm opacity-80">Video not supported</div>
                                    </div>
                                  </div>
                                </video>
                                
                                {/* Mobile Video Controls */}
                                <div className="absolute bottom-2 left-2 right-2">
                                  <div className="bg-white/20 backdrop-blur-md rounded-full px-3 py-1.5 flex items-center justify-center space-x-3">
                                    <button
                                      onClick={() => setIsPlaying(!isPlaying)}
                                      className="text-white hover:text-blue-300 transition-colors"
                                    >
                                      {isPlaying ? <Pause size={12} /> : <Play size={12} />}
                                    </button>
                                    <button
                                      onClick={() => setIsMuted(!isMuted)}
                                      className="text-white hover:text-blue-300 transition-colors"
                                    >
                                      {isMuted ? <VolumeX size={12} /> : <Volume2 size={12} />}
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      
                      {/* Browser Bottom Bar */}
                      <div className="bg-gray-900 px-3 lg:px-4 py-2 lg:py-3 flex items-center justify-between">
                        <div className="flex items-center space-x-1 lg:space-x-2 text-xs text-gray-400">
                          <span className="bg-gray-700 px-2 py-1 rounded text-xs">AA</span>
                          <span className="text-xs">🔒 http://localhost:3002</span>
                        </div>
                        <button className="text-gray-400 hover:text-white transition-colors">
                          <span className="text-sm">↻</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                // Enhanced Desktop View
                <div className="bg-white/80 backdrop-blur-xl rounded-2xl shadow-2xl overflow-hidden max-w-5xl mx-auto hover:shadow-3xl transition-all duration-500">
                  <div className="p-0 lg:p-12 flex items-center justify-center">
                    <div className="relative">
                      {/* Glowing background effect */}
                      <div className="absolute inset-0 bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 rounded-2xl blur-xl opacity-20 animate-pulse"></div>
                      
                      {/* Main container */}
                      <div className="relative border-2 border-dashed border-blue-400 rounded-2xl p-4 lg:p-8 bg-gradient-to-br from-blue-50/50 to-purple-50/50 backdrop-blur-sm">
                        <div className="text-sm text-blue-700 text-center mb-4 font-semibold flex items-center justify-center space-x-2">
                          <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                          <span>🎬 Live Video Advertisement</span>
                          <span className="w-2 h-2 bg-red-500 rounded-full animate-pulse"></span>
                        </div>
                        <AdContent />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Enhanced Right Sidebar */}
          <div className="w-80 bg-white/80 backdrop-blur-xl border-l border-gray-200/50 p-4 lg:p-6 hidden xl:block shadow-xl overflow-y-auto">
            <h3 className="text-xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-8">
              Creative Analytics
            </h3>
            
            <div className="space-y-6">
              <div className="bg-gradient-to-br from-purple-50 to-pink-50 rounded-xl p-6 shadow-lg hover:shadow-xl transition-shadow duration-300">
                <h4 className="font-bold text-purple-800 mb-4 flex items-center space-x-2">
                  <span className="w-2 h-2 bg-purple-500 rounded-full animate-pulse"></span>
                  <span>Video Details</span>
                </h4>
                <div className="space-y-4 text-sm">
                  <div className="flex justify-between items-center p-3 bg-white/60 rounded-lg">
                    <span className="font-medium text-gray-700">Dimension:</span>
                    <span className="bg-blue-100 text-blue-700 px-3 py-1 rounded-full font-semibold">{currentAd.dimension}</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-white/60 rounded-lg">
                    <span className="font-medium text-gray-700">Type:</span>
                    <span className="text-gray-600">Video - Autoplay</span>
                  </div>
                  <div className="flex justify-between items-center p-3 bg-white/60 rounded-lg">
                    <span className="font-medium text-gray-700">Creative ID:</span>
                    <span className="font-mono text-gray-600">{currentAd.creativeId}</span>
                  </div>
                  <div className="p-3 bg-white/60 rounded-lg">
                    <span className="font-medium text-gray-700 block mb-2">Properties:</span>
                    <div className="grid grid-cols-2 gap-2 text-xs">
                      {[
                        { label: 'Autoplay', value: 'On', color: 'green' },
                        { label: 'Muted', value: 'Yes', color: 'blue' },
                        { label: 'Loop', value: 'On', color: 'green' },
                        { label: 'Inline', value: 'Yes', color: 'blue' }
                      ].map((prop, i) => (
                        <div key={i} className="flex items-center justify-between">
                          <span>{prop.label}:</span>
                          <span className={`px-2 py-0.5 rounded-full text-xs font-semibold ${
                            prop.color === 'green' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'
                          }`}>
                            {prop.value}
                          </span>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <button className="w-full mt-4 bg-gradient-to-r from-blue-500 to-purple-500 text-white px-4 py-2 rounded-lg hover:from-blue-600 hover:to-purple-600 transition-all duration-300 transform hover:scale-105 shadow-lg">
                  View Full-Size
                </button>
              </div>

              {/* Enhanced QR Section */}
              <div className="text-center">
                <div className="inline-block p-4 bg-white rounded-xl shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="w-32 h-32 border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gradient-to-br from-gray-50 to-gray-100 hover:from-blue-50 hover:to-purple-50 transition-colors duration-300">
                    <QrCode size={64} className="text-gray-400 hover:text-blue-500 transition-colors duration-300" />
                  </div>
                  <p className="text-xs text-gray-500 mt-2">Scan to view</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Enhanced Mobile Menu Button */}
      <div className="lg:hidden fixed bottom-6 right-6">
        <button className="bg-gradient-to-r from-blue-500 to-purple-500 text-white p-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-110 transition-all duration-300 animate-bounce">
          <Monitor size={24} />
        </button>
      </div>
    </div>
  );
};

export default ZenDetail;